import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PMKusumSolar.css";

import heroBg from "../../assets/PMKusumsection1-bg.png";
import heroImg from "../../assets/PMKusumsection1.png";
import compImg from "../../assets/PMKusumsection3.png";
import compImgA from "../../assets/pmcomponent-a.png";
import compImgB from "../../assets/pmcomponent-b.png";
import compImgC from "../../assets/pmcomponent-c.png";
import sec4Img from "../../assets/PMKusumsection4.png";
import benefit1 from "../../assets/pmbenefits-1.png";
import benefit2 from "../../assets/pmbenefits-2.png";
import benefit3 from "../../assets/pmbenefits-3.png";
import benefit4 from "../../assets/pmbenefits-4.png";
import benefit5 from "../../assets/pmbenefits-5.png";
import iconA from "../../assets/PMKusumsection5-a.png";
import iconB from "../../assets/PMKusumsection5-b.png";
import iconC from "../../assets/PMKusumsection5-c.png";
import stage1 from "../../assets/stage1.png";
import stage2 from "../../assets/design.png";
import stage3 from "../../assets/validation.png";
import stage4 from "../../assets/eligibility.png";
import stage5 from "../../assets/solar.png";
import stage6 from "../../assets/design.png";
import stage7 from "../../assets/solar2.png";
import stage8 from "../../assets/maintainance.png";
import stage9 from "../../assets/solar.png";
import stage10 from "../../assets/training.png";
import trueRenewablesLogo from "../../assets/hiw_logo.svg";
import finalStep1 from "../../assets/finalstep1.png";
import finalStep2 from "../../assets/finalstep2.png";
import finalStep3 from "../../assets/finalstep3.png";
import stage11 from "../../assets/solar2.png";
import stage12 from "../../assets/solar3.png";
import sec6img1 from "../../assets/PMKusumsection6-1.png";
import sec6img2 from "../../assets/PMKusumsection6-2.png";
import sec6img3 from "../../assets/PMKusumsection6-3.png";
import whyImg from "../../assets/pmkusum-whychooseus.png";
import proj1 from "../../assets/CIRsection6-1.png";
import proj2 from "../../assets/CIRsection6-2.png";
import s1step1 from "../../assets/stage-1-1.png";
import s1step2 from "../../assets/stage-1-2.png";
import s1step3 from "../../assets/stage-1-3.png";
import s1step4 from "../../assets/stage-1-4.png";
import s1step5 from "../../assets/stage-1-5.png";
import s2step1 from "../../assets/stage-2-1.png";
import s2step2 from "../../assets/stage-2-2.png";
import s2step3 from "../../assets/stage-2-3.png";
import s2step4 from "../../assets/stage-2-4.png";
import s2step5 from "../../assets/home-stage2-step5.png";
import s3step1 from "../../assets/stage-3-1.png";
import s3step2 from "../../assets/stage-3-2.png";
import s3step3 from "../../assets/stage-3-3.png";
import s3step4 from "../../assets/stage-3-4.png";
import s3step5 from "../../assets/stage-3-5.png";
import s4step1 from "../../assets/stage-4-1.png";
import s4step2 from "../../assets/stage-4-2.png";
import s4step3 from "../../assets/stage-4-3.png";
import s4step4 from "../../assets/stage-4-4.png";
import s4step5 from "../../assets/stage-4-5.png";
import s5step1 from "../../assets/stage-5-1.png";
import s5step2 from "../../assets/stage-5-2.png";
import s5step3 from "../../assets/stage-5-3.png";
import s5step4 from "../../assets/stage-5-4.png";
import s5step5 from "../../assets/stage-5-5.png";
import s6step1 from "../../assets/stage-6-1.png";
import s6step2 from "../../assets/stage-6-2.png";
import s6step3 from "../../assets/stage-6-3.png";
import s6step4 from "../../assets/stage-6-4.png";
import s6step5 from "../../assets/home-stage6-step5.png";
import s7step1 from "../../assets/stage-7-1.png";
import s7step2 from "../../assets/stage-7-2.png";
import s7step3 from "../../assets/stage-7-3.png";
import s7step4 from "../../assets/stage-7-4.png";
import s7step5 from "../../assets/pmkusum-stage7-step5.png";
import s7step6 from "../../assets/stage-7-6.png";
import s8step1 from "../../assets/stage-8-1.png";
import s8step2 from "../../assets/stage-8-2.png";
import s8step3 from "../../assets/stage-8-3.png";
import s8step4 from "../../assets/stage-8-4.png";
import s8step5 from "../../assets/stage-8-5.png";
import s8step6 from "../../assets/stage-8-6.png";
import s9step1 from "../../assets/stage-9-1.png";
import s9step2 from "../../assets/stage-9-2.png";
import s9step3 from "../../assets/stage-9-3.png";
import s9step4 from "../../assets/stage-9-4.png";
import s9step5 from "../../assets/stage-9-5.png";
import s10step1 from "../../assets/stage-10-1.png";
import s10step2 from "../../assets/stage-10-2.png";
import s10step3 from "../../assets/stage-10-3.png";
import s10step4 from "../../assets/stage-10-4.png";
import s10step5 from "../../assets/stage-10-5.png";
import s10step6 from "../../assets/stage-10-6.png";
import s11step1 from "../../assets/stage-11-1.png";
import s11step2 from "../../assets/stage-11-2.png";
import s11step3 from "../../assets/stage-11-3.png";
import s11step4 from "../../assets/stage-11-4.png";
import s11step5 from "../../assets/stage-11-5.png";
import s11step6 from "../../assets/stage-11-6.png";
import s12step1 from "../../assets/stage-12-1.png";
import s12step2 from "../../assets/stage-12-2.png";
import s12step3 from "../../assets/stage-12-3.png";
import s12step4 from "../../assets/stage-12-4.png";
import s12step5 from "../../assets/stage-12-5.png";
import s12step6 from "../../assets/stage-12-6.png";

// import Testi1 from "../../assets/testi1.png";
// import Testi2 from "../../assets/testi2.png";
// import Testi3 from "../../assets/testi3.png";

// Add this after all imports, before any components
const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };

    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ================================================
   SECTION 1 — HERO
   ================================================ */
const KusumHero = () => {
  const navigate = useNavigate();
  return (
  <section className="ks-hero-wrapper">
    <div className="ks-hero">
      <div
        className="ks-hero-left"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="ks-hero-overlay" />
        <div className="ks-hero-content">
          <h1 className="ks-hero-title">
            Empowering India's Agriculture With Assured Solar Power
          </h1>
          <p className="ks-hero-desc">
            PM-KUSUM is a flagship MNRE initiative enabling reliable, low-cost
            solar power for farmers while easing DISCOM load.
          </p>
          <button className="ks-hero-btn" onClick={() => navigate("/contact")}>Book A Free Call</button>
        </div>
      </div>

      <div className="ks-hero-right">
        <img
          src={heroImg}
          alt="PM KUSUM Solar for Farmers"
          className="ks-hero-img"
        />
      </div>
    </div>
  </section>
  );
};

/* ================================================
   SECTION 2 — OVERVIEW
   ================================================ */
const KusumOverview = () => {
  const sectionRef = useRef(null);
  const wordsRef = useRef([]);

  const words =
    "PM-KUSUM (Kisan Urja Suraksha evam Utthaan Mahabhiyan) enables farmers and rural stakeholders to install solar assets with government-backed incentives and assured returns.".split(
      " ",
    );

  useEffect(() => {
    const onScroll = () => {
      const el = sectionRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const windowH = window.innerHeight;
      const progress = Math.min(
        Math.max((windowH - rect.top) / (windowH * 0.6), 0),
        1,
      );
      const total = wordsRef.current.length;
      wordsRef.current.forEach((span, i) => {
        if (!span) return;
        span.style.color = progress > i / total ? "#111111" : "#c0c0c0";
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="ks-overview" ref={sectionRef}>
      <div className="ks-overview-content">
        <p className="ks-overview-tag">
          <span className="ks-overview-dot" />
          OVERVIEW
        </p>
        <p className="ks-overview-text">
          {words.map((word, i) => (
            <span
              key={i}
              ref={(el) => (wordsRef.current[i] = el)}
              style={{ color: "#c0c0c0", transition: "color 0.25s ease" }}
            >
              {word}{" "}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3 — KUSUM COMPONENTS
   ================================================ */
const KusumComponents = () => {
  const [activeComp, setActiveComp] = useState(null);

  const components = [
    {
      key: "A",
      label: "Component A",
      desc: "Grid-connected ground-mount solar (0.5 MW–2 MW) for DISCOMs",
      img: compImgA,
    },
    {
      key: "B",
      label: "Component B",
      desc: "Stand-alone solar pumps for farmers",
      img: compImgB,
    },
    {
      key: "C",
      label: "Component C",
      desc: "Feeder-level solarization through distributed solar plants",
      img: compImgC,
    },
  ];

  return (
    <section className="ks-comp">
      {/* Floating image — changes per hovered component */}
      <div
        className={`ks-comp-img-wrap ${
          activeComp ? "ks-comp-img-wrap--visible" : ""
        }`}
      >
        <img
          src={
            activeComp
              ? components.find((c) => c.key === activeComp)?.img ?? compImg
              : compImg
          }
          alt="Component visual"
          className="ks-comp-img"
          loading="lazy"
        />
      </div>

      {/* Subtitle */}
      <p className="ks-comp-subtitle">
        The scheme has three components, each benefiting different stakeholders:
      </p>

      {/* Component rows */}
      <div className="ks-comp-rows">
        {components.map((c) => {
          const isActive = activeComp === c.key;
          return (
            <div key={c.key}>
              <div
                className={`ks-comp-row ${
                  isActive ? "ks-comp-row--active" : ""
                }`}
                onMouseEnter={() => setActiveComp(c.key)}
                onMouseLeave={() => setActiveComp(null)}
              >
                <div className="ks-comp-row-left">
                  <span className="ks-comp-dot" />
                  <span className="ks-comp-name">{c.label}</span>
                </div>
                <span className="ks-comp-desc">{c.desc}</span>
              </div>
              <hr className="ks-comp-divider" />
            </div>
          );
        })}
      </div>
    </section>
  );
};

/* ================================================
   SECTION 4 — BENEFITS
   ================================================ */
const ksBenefitItems = [
  {
    title: "Guaranteed income for 25 years",
    desc: "Farmers can lease unused or non-cultivable land to set up solar plants and earn a fixed annual income.",
    img: benefit1,
  },
  {
    title: "Zero fuel cost for irrigation",
    desc: "Solar pumps eliminate diesel expenses and provide reliable day-time power.",
    img: benefit2,
  },
  {
    title: "Increased farm productivity",
    desc: "Assured power → more control over irrigation → stable crop cycles.",
    img: benefit3,
  },
  {
    title: "No investment required for most programs",
    desc: "Majority of capital is covered through subsidies or investor participation.",
    img: benefit4,
  },
  {
    title: "Long-term asset creation for rural India",
    desc: "Solar plants increase land value and create new rural employment opportunities.",
    img: benefit5,
  },
];

const KusumBenefits = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const outerRef = useRef(null);
  const activeIndexRef = useRef(0);

  /* ── Pin the panel while scrolling through the outer (tall) wrapper,
     driving activeIndex from scroll progress. ── */
  useEffect(() => {
    let raf;

    const update = () => {
      const el = outerRef.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        const totalScroll = el.offsetHeight - window.innerHeight;
        const scrolled = -rect.top;
        const p =
          totalScroll > 0
            ? Math.max(0, Math.min(scrolled / totalScroll, 1))
            : 0;

        const idx = Math.min(
          ksBenefitItems.length - 1,
          Math.floor(p * ksBenefitItems.length)
        );

        if (idx !== activeIndexRef.current) {
          activeIndexRef.current = idx;
          setActiveIndex(idx);
        }
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    const timer = setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className="ks-benefits-outer"
      ref={outerRef}
      style={{ height: `${ksBenefitItems.length * 110}vh` }}
    >
      <section className="ks-benefits-sticky">
        <div className="ks-benefits">
          <div className="ks-benefits-header">
            <p className="ks-benefits-tag">
              <span className="ks-benefits-dot" />
              BENEFITS
            </p>
            <h2 className="ks-benefits-title">
              A Program Built For Scale And Stability
            </h2>
          </div>

          <div className="ks-benefits-body">
            <div className="ks-benefits-list">
              {ksBenefitItems.map((item, i) => (
                <div key={i}>
                  <div
                    className={`ks-benefit-item ${
                      i === activeIndex ? "ks-benefit-item--active" : ""
                    }`}
                    onClick={() => setActiveIndex(i)}
                  >
                    {/* Orange bar — only for active */}
                    {i === activeIndex && <span className="ks-benefit-bar" />}

                    <div className="ks-benefit-text">
                      <p className="ks-benefit-title">{item.title}</p>

                      {/* Desc — only for active, animates in */}
                      {i === activeIndex && (
                        <p className="ks-benefit-desc">{item.desc}</p>
                      )}
                    </div>
                  </div>

                  {/* Mobile-only inline image — appears below the active item */}
                  <div className="ks-benefit-mobile-img-wrap">
                    <div className="ks-benefit-mobile-img-bg" />
                    <img
                      src={item.img}
                      alt={item.title}
                      className="ks-benefit-mobile-img"
                      loading="lazy"
                    />
                  </div>

                  {i < ksBenefitItems.length - 1 && (
                    <hr className="ks-benefit-divider" />
                  )}
                </div>
              ))}
            </div>

            <div className="ks-benefits-img-wrap">
              <div className="ks-benefits-img-bg" />
              <img
                src={ksBenefitItems[activeIndex].img}
                alt="PM KUSUM Benefits"
                className="ks-benefits-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
/* ================================================
   SECTION 5 — ADVANTAGES
   ================================================ */
const KusumAdvantages = () => {
  const cards = [
    {
      icon: iconA,
      label: "COMPONENT A",
      title: "(0.5–2 MW Ground-Mount Solar)",
      bullets: [
        "No subsidy to farmers (investment by developer/RESCO)",
        "DISCOM buys power at a pre-defined tariff",
        "Farmer earns annual lease income",
        "Developer earns from long-term PPA",
      ],
    },
    {
      icon: iconB,
      label: "COMPONENT B",
      title: "Standalone Pumps",
      bullets: [
        "Up to 60–90% subsidy depending on state",
        "Farmer contribution: 10–30%",
        "Zero diesel cost & minimal maintenance",
      ],
    },
    {
      icon: iconC,
      label: "COMPONENT C",
      title: "Feeder Solarization",
      bullets: [
        "Subsidy shared among MNRE, DISCOM, and Farmer",
        "Power supply stabilized",
        "Feeder losses reduced",
      ],
    },
  ];

  return (
    <section className="ks-adv">
      {/* Header */}
      <div className="ks-adv-header">
        <p className="ks-adv-tag">
          <span className="ks-adv-dot" />
          ADVANTAGES
        </p>
        <h2 className="ks-adv-title">
          Subsidy Structure &amp; Commercial Advantages
        </h2>
      </div>

      {/* Cards */}
      <div className="ks-adv-cards">
        {cards.map((c, i) => (
          <div className="ks-adv-card" key={i}>
            <img src={c.icon} alt={c.label} className="ks-adv-icon" loading="lazy" />
            <div className="ks-adv-card-body">
              <div className="ks-adv-card-top">
                <p className="ks-adv-label">{c.label}</p>
                <p className="ks-adv-card-title">{c.title}</p>
              </div>
              <ul className="ks-adv-list">
                {c.bullets.map((b, j) => (
                  <li key={j} className="ks-adv-list-item">
                    <svg
                      width="15"
                      height="11"
                      viewBox="0 0 15 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="ks-adv-check"
                      aria-hidden="true"
                    >
                      <path
                        d="M1 5L5.5 9.5L14 1"
                        stroke="#6D6E70"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* Footer note */}
      <p className="ks-adv-note">
        Clear, transparent, and aligned with MNRE guidelines.
      </p>
    </section>
  );
};

/* ================================================
   4. HOW IT WORKS SECTION
   ================================================ */
const stages = [
  {
    id: 1,
    title: "Feasibility & Site Asessment",
    steps: [
      { title: "Land assessment (topography, contour, soil testing)", image: s1step1 },
      { title: "Irradiation analysis & shadow simulation", image: s1step2 },
      { title: "Grid proximity & evacuation feasibility", image: s1step3 },
      { title: "Access road & logistics evaluation", image: s1step4 },
      { title: "Preliminary DISCOM feasibility fitment", image: s1step5 },
    ],
  },
  {
    id: 2,
    title: "Design & Engineering",
    steps: [
      { title: "Plant capacity sizing (0.5–2 MW)", image: s2step1 },
      { title: "Module / inverter selection", image: s2step2 },
      { title: "Array layout & string configuration", image: s2step3 },
      { title: "SLDs, cable sizing & electrical schematics", image: s2step4 },
      { title: "Grid study & protection system planning", image: s2step5 },
    ],
  },
  {
    id: 3,
    title: "Financial Modelling",
    steps: [
      { title: "Tariff modelling & revenue forecast", image: s3step1 },
      { title: "CAPEX planning / investor structuring", image: s3step2 },
      { title: "PPA scenario planning with DISCOM", image: s3step3 },
      { title: "IRR, payback & risk mapping", image: s3step4 },
      { title: "Bankability & funding prep", image: s3step5 },
    ],
  },
  {
    id: 4,
    title: "Documentation Prep",
    steps: [
      { title: "Land records, KYC, ownership proofs", image: s4step1 },
      { title: "CAPEX Survey documents, FMB/layout maps", image: s4step2 },
      { title: "Required DISCOM formats", image: s4step3 },
      { title: "MNRE eligibility documents", image: s4step4 },
      { title: "Draft PPA review & preparation planning / investor structuring", image: s4step5 },
    ],
  },
  {
    id: 5,
    title: "Applications & Approvals",
    steps: [
      { title: "MNRE / State portal application", image: s5step1 },
      { title: "DISCOM feasibility approval", image: s5step2 },
      { title: "CEIG/CEA compliance planning", image: s5step3 },
      { title: "Approval tracker inside TrueTrack™", image: s5step4 },
      { title: "Real-time status visible to client", image: s5step5 },
    ],
  },
  {
    id: 6,
    title: "Engineering & Procurement",
    steps: [
      { title: "Final BOQ & vendor locking", image: s6step1 },
      { title: "Module, inverter, transformer, MMS procurement", image: s6step2 },
      { title: "Delivery schedules tracked in-app", image: s6step3 },
      { title: "Civil design, geotechnical validation", image: s6step4 },
      { title: "Digital QA of materials before dispatch", image: s6step5 },
    ],
  },
  {
    id: 7,
    title: "EPC Execution",
    steps: [
      { title: "Daily site logs: photos, videos, progress %", image: s7step1 },
      { title: "Civil, MMS, DC & AC milestones tracked digitally", image: s7step2 },
      { title: "Workfront readiness & manpower mapping", image: s7step3 },
      { title: "Material movement & consumption", image: s7step4 },
      { title: "Automated alerts for delays", image: s7step5 },
      { title: "Client dashboard: complete transparency", image: s7step6 },
    ],
  },
  {
    id: 8,
    title: "Testing & Commissioning",
    steps: [
      { title: "Module/inverter testing & safety validation", image: s8step1 },
      { title: "Transformer, HT panel, LT panel testing", image: s8step2 },
      { title: "Meter installation & DISCOM coordination", image: s8step3 },
      { title: "CEIG inspection & approvals", image: s8step4 },
      { title: "Grid synchronization and final energization", image: s8step5 },
      { title: "Handover package auto-generated", image: s8step6 },
    ],
  },
  {
    id: 9,
    title: "Live Monitoring",
    steps: [
      { title: "Real-time generation, PR, CUF & grid export", image: s9step1 },
      { title: "Inverter / string-level diagnostics", image: s9step2 },
      { title: "Weather, temperature & soiling impact modeling", image: s9step3 },
      { title: "AI alerts for underperformance", image: s9step4 },
      {
        title: "Dual dashboards:",
        image: s9step5,
        bullets: [
          "Engineering dashboard (SCADA, granular data)",
          "Owner dashboard (simple uptime, generation, savings)"
        ]
      },
    ],
  },
  {
    id: 10,
    title: "Maintenance & Asset Health",
    steps: [
      { title: "Preventive maintenance scheduling (cleaning, tightening, vegetation)", image: s10step1 },
      { title: "Corrective maintenance with SLA-bound ticketing", image: s10step2 },
      { title: "Thermography & drone inspections", image: s10step3 },
      { title: "AC & DC side servicing logs", image: s10step4 },
      { title: "Monthly digital plant health reports", image: s10step5 },
      { title: "Downtime, root cause analysis, corrective actions", image: s10step6 },
    ],
  },
  {
    id: 11,
    title: "Billing & Settlements",
    steps: [
      { title: "Automated monthly energy billing", image: s11step1 },
      { title: "Export energy reconciliation with DISCOM", image: s11step2 },
      { title: "Payment tracking & due-date reminders", image: s11step3 },
      { title: "Revenue dashboards for investors", image: s11step4 },
      { title: "Monthly PPA performance", image: s11step5 },
      { title: "Energy accounting for audits", image: s11step6 },
    ],
  },
  {
    id: 12,
    title: "Lifecycle Reporting",
    steps: [
      { title: "Monthly & annual performance reports", image: s12step1 },
      { title: "PPA compliance documentation", image: s12step2 },
      { title: "CEIG/CEA renewal reminders", image: s12step3 },
      { title: "Data exports for banks, auditors & government", image: s12step4 },
      { title: "Carbon credit & REC eligibility mapping", image: s12step5 },
      { title: "Long-term asset performance benchmarking", image: s12step6 },
    ],
  },
];

const N = stages.length;
const RADIUS = 380;
const ANGLE_STEP = 30;
const MINOR_TICKS = 72;

const HowItWorks = () => {
  const sectionRef = useRef(null);

  const dialRef = useRef(null);
  const numRefs = useRef([]);
  const tickRefs = useRef([]);
  const itemRefs = useRef([]);
  const cardsContainerRef = useRef(null);
  const arcRef = useRef(null);

  const activeStageRef = useRef(0);
  const logoRef = useRef(null);

  const [activeIdx, setActiveIdx] = useState(0);
  const [isMobilePopupOpen, setIsMobilePopupOpen] = useState(false);

  useEffect(() => {
    let raf;
    const update = () => {
      const el = sectionRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      const headerEl = el.querySelector(".hiw-header-wrap");
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;

      const startDelay = headerHeight + window.innerHeight * 0.2;
      const totalScroll = el.offsetHeight - window.innerHeight - startDelay;
      const scrolled = -rect.top - startDelay;

      const p = Math.max(0, Math.min(scrolled / totalScroll, 1));
      const arcFloat = p * N;
      const activeFloat = Math.min(arcFloat, N - 1);
      const activeIndex = Math.round(activeFloat);

      const currentRotation = -(activeFloat * ANGLE_STEP);
      const mobileOffset = window.innerWidth <= 1024 ? -90 : 0;

      if (dialRef.current) {
        dialRef.current.style.transform = `translate(-50%, -50%) rotate(${currentRotation + mobileOffset}deg)`;
      }

      if (logoRef.current) {
        const logoOffset = window.innerWidth <= 1024 ? 90 : 0;
        logoRef.current.style.transform = `rotate(${currentRotation + logoOffset}deg)`;
      }

      stages.forEach((_, i) => {
        const numEl = numRefs.current[i];
        const tickEl = tickRefs.current[i];
        const itemEl = itemRefs.current[i];
        if (!numEl || !tickEl || !itemEl) return;

        const dist = activeFloat - i;
        let opacity = 1;

        if (Math.abs(dist) < 0.5) {
          opacity = 0;
        } else if (dist > 0.5) {
          opacity = Math.max(0, 1 - (dist - 0.5) * 0.4);
        } else if (dist < -5) {
          opacity = 0;
        }

        numEl.style.opacity = opacity;
        tickEl.style.opacity = 1;
        itemEl.style.opacity = opacity;

        numEl.style.transform = `rotate(${-(i * ANGLE_STEP) - currentRotation - mobileOffset}deg)`;
      });

      if (arcRef.current) {
        const progress = Math.max(0, Math.min(arcFloat, N)) / 12;
        const circ = 2 * Math.PI * 333;
        arcRef.current.style.strokeDashoffset = circ - progress * circ;
      }

      if (activeIndex !== activeStageRef.current) {
        activeStageRef.current = activeIndex;
        setActiveIdx(activeIndex);
      }

      raf = requestAnimationFrame(update);
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    setTimeout(() => update(), 100);
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  const currentStage = stages[activeIdx];
  const numStr = (activeIdx + 1).toString().padStart(2, "0");
  const cardsData = currentStage.steps;
  const stepImages = [finalStep1, finalStep2, finalStep3];

  const scrollCards = (direction) => {
    if (cardsContainerRef.current) {
      const scrollAmount = cardsContainerRef.current.offsetWidth;
      cardsContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      className="hiw-outer"
      ref={sectionRef}
      style={{ height: `${stages.length * 110}vh` }}
    >
      <div className="hiw-header-wrap">
        <div className="hiw-tag">
          <span className="hiw-dot"></span>
          HOW IT WORKS
        </div>
        <h2 className="hiw-title">
          True 360° Execution —<br />
          Zero-Stress, End-to-End Solar
        </h2>
        <p className="hiw-subtitle">
          A transparent, predictable, 12-stage execution framework that ensures
          every project — Government, Corporate or Residential — is delivered
          with absolute clarity and control.
        </p>
      </div>

      <div className="hiw-sticky">
        <div className="hiw-split">
          {/* LEFT SIDE: DIAL */}
          <div className="hiw-left">
            <div className="hiw-mobile-header">
              <div className="hiw-tag">
                <span className="hiw-dot"></span>
                HOW IT WORKS
              </div>
              <h2 className="hiw-title">
                True 360° Execution —<br />
                Zero-Stress, End-to-End Solar
              </h2>
              <p className="hiw-subtitle">
                A transparent, predictable, 12-stage execution framework that
                ensures every project — Government, Corporate or Residential —
                is delivered with absolute clarity and control.
              </p>
            </div>

            <div className="hiw-dial-wrapper">
              <div className="hiw-dial-container" ref={dialRef}>
                <div className="hiw-dial-bg"></div>
                <div className="hiw-dial-inner-orange"></div>

                {Array.from({ length: MINOR_TICKS }).map((_, i) => (
                  <div
                    key={`tick-${i}`}
                    className="hiw-dial-tick-min"
                    style={{
                      transform: `rotate(${i * (360 / MINOR_TICKS)}deg) translate(${RADIUS}px)`,
                    }}
                  />
                ))}

                <svg
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "678px",
                    height: "678px",
                    pointerEvents: "none",
                    zIndex: 2,
                  }}
                >
                  <circle
                    ref={arcRef}
                    cx="339"
                    cy="339"
                    r="333"
                    fill="none"
                    stroke="#F05A28"
                    strokeWidth="6"
                    strokeDasharray={2 * Math.PI * 333}
                    strokeDashoffset={2 * Math.PI * 333}
                    strokeLinecap="round"
                  />
                </svg>

                {stages.map((stage, i) => {
                  const itemAngle = i * ANGLE_STEP;
                  const isActive = i === activeIdx;
                  const isPast = i < activeIdx;

                  return (
                    <React.Fragment key={stage.id}>
                      <div
                        className={`hiw-dial-tick-maj ${isActive ? "active" : ""} ${isPast ? "past" : ""}`}
                        ref={(el) => (tickRefs.current[i] = el)}
                        style={{
                          transform: `rotate(${itemAngle}deg) translate(${RADIUS}px)`,
                        }}
                      />
                      <div
                        className={`hiw-dial-item ${isPast ? "past" : ""}`}
                        ref={(el) => (itemRefs.current[i] = el)}
                        style={{
                          transform: `rotate(${itemAngle}deg) translate(${RADIUS + 40}px)`,
                        }}
                      >
                        <div
                          className="hiw-dial-num"
                          ref={(el) => (numRefs.current[i] = el)}
                          style={{ transform: "rotate(-90deg)" }}
                        >
                          {(i + 1).toString().padStart(2, "0")}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>

              <div className="hiw-dial-inner">
                <img
                  src={trueRenewablesLogo}
                  alt="True Renewables"
                  className="hiw-center-logo"
                  ref={logoRef}
                  loading="lazy"
                />
                <div className="hiw-dial-pointer"></div>
              </div>

              <div className="hiw-active-overlay">
                <div className="hiw-inner-faint-line"></div>
                <div className="hiw-active-thick-line"></div>
                <div className="hiw-active-dot"></div>
                <div className="hiw-active-text-block">
                  <span className="hiw-active-num">{numStr}</span>
                  <span className="hiw-active-title">{currentStage.title}</span>
                </div>
              </div>
            </div>

            <div className="hiw-mobile-info">
              <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
              <h3 className="hiw-mobile-title">{currentStage.title}</h3>
              <p className="hiw-mobile-desc">
                {currentStage.steps.map((s) => s.title).join(", ")}
              </p>
              <button
                className="hiw-mobile-view-btn"
                onClick={() => setIsMobilePopupOpen(true)}
              >
                VIEW DETAILS ↗
              </button>
            </div>
          </div>

          {/* RIGHT SIDE: CONTENT */}
          <div className={`hiw-right ${isMobilePopupOpen ? "mobile-open" : ""}`}>
            <div
              className="hiw-popup-bg"
              onClick={() => setIsMobilePopupOpen(false)}
            ></div>
            <div className="hiw-popup-inner">
              <button
                className="hiw-popup-close"
                onClick={() => setIsMobilePopupOpen(false)}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>

              <div className="hiw-stage-badge">STAGE {numStr}</div>
              <h2 className="hiw-right-title">{currentStage.title}</h2>

              <div className="hiw-cards-container" ref={cardsContainerRef}>
                {cardsData.map((step, idx) => (
                  <div key={idx} className="hiw-step-card">
                    <div className="hiw-step-img-wrap">
                      <img
                        src={step.image}
                        alt={step.title}
                        className="hiw-step-img"
                        loading="lazy"
                      />
                    </div>
                    <div className="hiw-step-text">
                      <p className="hiw-step-num">STEP {idx + 1}</p>
                      <h4 className="hiw-step-title">{step.title}</h4>
                      {step.bullets && (
                        <ul className="hiw-step-bullets">
                          {step.bullets.map((bullet, i) => (
                            <li key={i} className="hiw-step-bullet">{bullet}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="hiw-nav-arrows">
                <button
                  type="button"
                  className="hiw-nav-arrow"
                  onClick={() => scrollCards("left")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                <button
                  type="button"
                  className="hiw-nav-arrow"
                  onClick={() => scrollCards("right")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>

              <div className="hiw-popup-mobile-info">
                <div className="hiw-mobile-stage">STAGE {activeIdx + 1}</div>
                <h3 className="hiw-mobile-title">{currentStage.title}</h3>
                <p className="hiw-mobile-desc">
                  {currentStage.steps.map((s) => s.title).join(", ")}
                </p>
                <button
                  className="hiw-mobile-view-btn popup-btn"
                  onClick={() => setIsMobilePopupOpen(false)}
                >
                  VIEW DETAILS ↗
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
/* ================================================
   SECTION 6 — OUR JOURNEY
   ================================================ */
const KusumJourney = () => {
  const [currentCard, setCurrentCard] = useState(0);
  const cards = [
    {
      num: "01",
      stage: "EPC Execution Stage",
      img: sec6img1,
      name: "TrueTrack™ App",
      desc: "Project tracking, milestones, daily reporting",
    },
    {
      num: "02",
      stage: "O&M Stage",
      img: sec6img2,
      name: "TrueCare™ O&M Portal",
      desc: "Monitoring, AI alerts, AMC management",
    },
    {
      num: "03",
      stage: "Commercial & Compliance Stage",
      img: sec6img3,
      name: "TrueCom™ Dashboard",
      desc: "Billing, settlements, ROI insights",
    },
  ];

  return (
    <section className="ks-journey">
      {/* Header */}
      <div className="ks-journey-header">
        <p className="ks-journey-tag">
          <span className="ks-journey-dot" />
          OUR JOURNEY
        </p>
        <h2 className="ks-journey-title">The PM KUSUM Journey</h2>
      </div>

      {/* Cards */}
      <div className="ks-journey-cards">
        {cards.map((c, i) => (
          <div
            className={`ks-journey-card${i === currentCard ? " ks-journey-card--active" : ""}`}
            key={i}
          >
            {/* Stage label row */}
            <div className="ks-journey-stage-row">
              <span className="ks-journey-num">{c.num}</span>
              <span className="ks-journey-stage">{c.stage}</span>
            </div>

            {/* Image with gradient overlay */}
            <div className="ks-journey-img-wrap">
              <img src={c.img} alt={c.name} className="ks-journey-img" loading="lazy" />
            </div>

            {/* Card info */}
            <div className="ks-journey-card-info">
              <p className="ks-journey-card-name">{c.name}</p>
              <p className="ks-journey-card-desc">{c.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Footer note */}
       <div className="ks-journey-nav">
        <button
          className="ks-journey-nav-btn"
          onClick={() => setCurrentCard((c) => (c - 1 + cards.length) % cards.length)}
          aria-label="Previous"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <button
          className="ks-journey-nav-btn"
          onClick={() => setCurrentCard((c) => (c + 1) % cards.length)}
          aria-label="Next"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>

      {/* Footer note */}
      <p className="ks-journey-note">
        Each platform is fully interlinked, creating a unified, end-to-end
        <br />
        solar lifecycle management system.
      </p>
    </section>
  );
};
/* ── SECTION 7 — WHY CHOOSE US ── */
const KusumWhyChooseUs = () => {
  const leftCards = [
    {
      num: "01",
      text: "Strong experience in government-linked solar execution.",
    },
    {
      num: "02",
      text: "Deep expertise in DISCOM coordination and MNRE processes.",
    },
    { num: "03", text: "End-to-end service: Engineering → Approvals → AMC." },
  ];
  const rightCards = [
    {
      num: "04",
      text: "TrueTrack platform for transparent, real-time progress.",
    },
    { num: "05", text: "Zero-compromise procurement and quality standards." },
    { num: "06", text: "Faster execution with strict safety and compliance." },
  ];

  return (
    <section className="ks-why">
      <div className="ks-why-header">
        <p className="ks-why-tag">
          <span className="ks-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="ks-why-title">
          Built For PM-KUSUM.
          <br />
          Trusted On Ground.
        </h2>
      </div>

      <div className="ks-why-body">
        <div className="ks-why-col">
          {leftCards.map((c) => (
            <div className="ks-why-card" key={c.num}>
              <p className="ks-why-num">{c.num}</p>
              <p className="ks-why-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="ks-why-img-wrap">
          <img src={whyImg} alt="Why Choose Us" className="ks-why-img" loading="lazy" />
        </div>

        <div className="ks-why-col">
          {rightCards.map((c) => (
            <div className="ks-why-card" key={c.num}>
              <p className="ks-why-num">{c.num}</p>
              <p className="ks-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ── SECTION 8 — FEATURED PROJECTS ── */
const KusumFeaturedProjects = () => {
  const projects = [
    {
      img: proj1,
      title: "PM-KUSUM Solar Feeder Project",
      desc: "Grid-connected solar feeder supplying clean power to agricultural pumps with assured returns.",
      tags: ["MAHARASHTRA", "2 MW"],
    },
    {
      img: proj2,
      title: "Farmer-Owned Solar Plant (KUSUM-C)",
      desc: "Decentralized ground-mounted solar plant enabling farmers to sell surplus power to DISCOMs.",
      tags: ["RAJASTHAN", "CAPTIVE + SALE", "50 kW"],
    },
  ];

  return (
    <section className="ks-projects">
      <div className="ks-projects-header">
        <p className="ks-projects-tag">
          <span className="ks-projects-dot" />
          FEATURED PROJECTS
        </p>
        <h2 className="ks-projects-title">Projects Powering Rural India</h2>
      </div>

      <div className="ks-projects-grid">
        {projects.map((p, i) => (
          <div className="ks-projects-card" key={i}>
            <div className="ks-projects-img-wrap">
              <img src={p.img} alt={p.title} className="ks-projects-card-img" loading="lazy" />
            </div>
            <div className="ks-projects-card-body">
              <h3 className="ks-projects-card-title">{p.title}</h3>
              <p className="ks-projects-card-desc">{p.desc}</p>
              <div className="ks-projects-tags">
                {p.tags.map((tag, j) => (
                  <span className="ks-projects-tag-pill" key={j}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
// /* ================================================
//    5. TESTIMONIALS
//    ================================================ */
// const Testimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       name: "Anjali Verma",
//       role: "Property Owner, Bengaluru",
//       quote:
//         '"True Renewables made our solar installation simple and hassle-free. The team was professional throughout the process."',
//       photo: Testi1,
//     },
//     {
//       id: 2,
//       name: "Sandeep Reddy",
//       role: "Managing Director, Reddy Commercial Spaces",
//       quote:
//         '"The installation was smooth and the system is performing very well. A reliable team to work with."',
//       photo: Testi2,
//     },
//     {
//       id: 3,
//       name: "Harshvardhan Kulkarni",
//       role: "Director, Altura Industrial Solutions",
//       quote:
//         '"True Renewables delivered a dependable solar solution for our facility and helped reduce our energy costs."',

//       photo: Testi3,
//     },
//   ];

//   // ── TESTIMONIAL CARD ──
//   const TestimonialCard = ({ item, animClass }) => (
//     <div className={`testi-card ${animClass || ""}`}>
//       <div className="testi-card-content">
//         <div className="testi-person">
//           <div>
//             <p className="testi-name">{item.name}</p>
//             <p className="testi-role">{item.role}</p>
//           </div>
//         </div>
//         <hr className="testi-divider" />
//         <p className="testi-quote">{item.quote}</p>
//       </div>
//       <div className="testi-card-photo">
//         {item.photo ? (
//           <img src={item.photo} alt={item.name} className="testi-photo" />
//         ) : (
//           <div className="testi-photo-placeholder" />
//         )}
//       </div>
//     </div>
//   );

//   const ChevronLeft = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   );

//   const ChevronRight = () => (
//     <svg
//       width="18"
//       height="18"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   );

//   const [current, setCurrent] = useState(0);
//   const [slideDir, setSlideDir] = useState("");
//   const [animKey, setAnimKey] = useState(0);
//   const headerRef = useReveal();
//   const total = testimonials.length;

//   const prev = () => {
//     setSlideDir("testi-slide-left");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c - 1 + total) % total);
//   };

//   const next = () => {
//     setSlideDir("testi-slide-right");
//     setAnimKey((k) => k + 1);
//     setCurrent((c) => (c + 1) % total);
//   };

//   return (
//     <section className="testi-section">
//       <div className="testi-header reveal-block" ref={headerRef}>
//         <div className="testi-header-left">
//           <p className="testi-tag">
//             <span className="testi-dot"></span> TESTIMONIALS
//           </p>
//           <h2 className="testi-title">
//             Trusted By Clients Across
//             <br />
//             Industries
//           </h2>
//         </div>
//         <div className="testi-header-right">
//           <p className="testi-subtitle">
//             Real experiences from clients who trust us
//             <br />
//             with their solar journey.
//           </p>
//           <div className="testi-arrows testi-arrows-header">
//             <button
//               className="testi-arrow"
//               onClick={prev}
//               aria-label="Previous testimonial"
//             >
//               <ChevronLeft />
//             </button>
//             <button
//               className="testi-arrow"
//               onClick={next}
//               aria-label="Next testimonial"
//             >
//               <ChevronRight />
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="testi-cards" key={animKey}>
//         <TestimonialCard
//           item={testimonials[current % total]}
//           animClass={slideDir}
//         />
//         <TestimonialCard
//           item={testimonials[(current + 1) % total]}
//           animClass={`${slideDir} testi-delay`}
//         />
//       </div>
//     </section>
//   );
// };

/* ================================================
   MAIN PAGE
   ================================================ */
const PMKusumSolar = () => (
  <>
    <KusumHero />
    <KusumOverview />
    <KusumComponents />
    <KusumBenefits />
    <KusumAdvantages />
    <HowItWorks />
    <KusumJourney />
    <KusumWhyChooseUs />
    <KusumFeaturedProjects />
    {/* <Testimonials />     */}
  </>
);

export default PMKusumSolar;
